import { Routes, Route } from "react-router-dom";
import { Home } from "../pages/Home";
import { About } from '../pages/About';
import { Contact } from "../pages/Contact";
import { LeasingStore } from "../pages/leasing-store/LeasingStore";
import { ProductDetails } from "../pages/leasing-store/ProductDetails";
import { CustomRequest } from "../pages/leasing-store/CustomRequest";
import { UnderDevelopment } from "../components/ui/UnderDevelopment";
import { Team } from "../pages/Team";
import { FullscreenChat } from "../pages/chat/FullscreenChat";
import Tarification from '../pages/Tarification';
import FaqPage from '../pages/Faq';
import Terms from '../pages/Terms';
import { Callback } from '../pages/auth/Callback';
import Profile from '../pages/Profile';
import Abonnement from '../pages/Abonnement';
import CompanyPage from '../pages/Company';
import FinancialInstitutionPage from '../pages/FinancialInstitution';
import { ProtectedRoute } from "../components/auth/ProtectedRoute";
import { CompanyAdminRoute } from "../components/auth/CompanyAdminRoute";
import AllApplications from '../pages/AllApplications';
import AppDetail from '../pages/AppDetail';
import Developer from '../pages/Developer';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/products/*"
        element={
          <UnderDevelopment
            pageName="Produits"
            description="Notre catalogue de produits est en cours de développement."
            showBody={true}
          />
        }
      />
      <Route
        path="/pricing"
        element={
          <UnderDevelopment
            pageName="Tarification"
            description="Nos offres et tarifs seront bientôt disponibles."
            showBody={true}
          />
        }
      />
      <Route
        path="/blog"
        element={
          <UnderDevelopment
            pageName="Blog"
            description="Notre blog est en cours de développement."
          />
        }
      />
      <Route
        path="/faq"
        element={<FaqPage />}
      />
      <Route
        path="/contact"
        element={
          <UnderDevelopment
            pageName="Contact"
            description="Notre page de contact est en cours de développement."
          />
        }
      />
      <Route
        path="/resources"
        element={
          <UnderDevelopment
            pageName="Ressources"
            description="Notre centre de ressources est en cours de développement."
          />
        }
      />
      {/* Leasing Store */}
      <Route path="/leasing-store">
        <Route index element={<LeasingStore />} />
        <Route path="product/:id" element={<ProductDetails />} />
        <Route path="custom-request" element={<CustomRequest />} />
      </Route>
      {/* Pages statiques */}
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/team" element={<Team />} />
      <Route path="/tarification" element={<Tarification />} />
      <Route path="/terms" element={<Terms />} />
      
      {/* Routes protégées nécessitant une authentification */}
      {/* Profil : accessible à TOUS les utilisateurs authentifiés (admin et membres) */}
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

      {/* Pages de gestion entreprise/institution : RÉSERVÉES à l'admin/propriétaire.
          Les non-admins (comptables, managers, employés) n'y ont pas accès et sont
          redirigés vers leur profil. Les "nouveaux utilisateurs" (sans company encore)
          ont le droit d'accéder à `/company` ou `/financial-institution` pour créer
          leur structure — d'où `allowNewAccounts={true}` sur ces routes. */}
      <Route path="/company" element={<CompanyAdminRoute allowNewAccounts><CompanyPage /></CompanyAdminRoute>} />
      <Route path="/company/:companyId" element={<CompanyAdminRoute><CompanyPage /></CompanyAdminRoute>} />
      <Route path="/financial-institution" element={<CompanyAdminRoute allowNewAccounts><FinancialInstitutionPage /></CompanyAdminRoute>} />
      <Route path="/financial-institution/:institutionId" element={<CompanyAdminRoute><FinancialInstitutionPage /></CompanyAdminRoute>} />
      <Route path="/organization" element={<CompanyAdminRoute><CompanyPage /></CompanyAdminRoute>} />

      {/* Abonnement : strictement admin (souscription, facturation) — pas d'exception pour les nouveaux */}
      <Route path="/abonnement" element={<CompanyAdminRoute><Abonnement /></CompanyAdminRoute>} />
      
      <Route
        path="/unauthorized"
        element={
          <UnderDevelopment
            pageName="Accès non autorisé"
            description="Vous n'avez pas les permissions nécessaires pour accéder à cette page."
          />
        }
      />
      <Route path="/auth/callback" element={<Callback />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/chat" element={<ProtectedRoute><FullscreenChat /></ProtectedRoute>} />
      <Route path="/applications" element={<AllApplications />} />
      <Route path="/applications/:id" element={<AppDetail />} />
      <Route path="/developpeur" element={<Developer />} />
    </Routes>
  );
}
